import React, { useState } from 'react';
import { getProficiencyConfig, getProficiencyLevels } from '../utils/skillHelpers';

const PlaySkillFocus = ({ playSkill, handleUpdate, handleExit }) => {
  const [attempts, setAttempts] = useState(playSkill.attempts);
  const [proficiency, setProficiency] = useState(playSkill.proficiency);

  const config = getProficiencyConfig(playSkill.proficiency);
  const proficiencyLevels = getProficiencyLevels();

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full mx-4 overflow-hidden">
        <div className={`${config.bg} p-6 text-center`}>
          <div className="text-4xl mb-2">{config.emoji}</div>
          <h2 className="text-2xl font-bold text-white drop-shadow-lg mb-1">
            {playSkill.name}
          </h2>
          <p className="p-style text-sm"  style={{color: 'RGBA(255,255,255,0.9)'}}>
            {config.description}
          </p>
        </div>

        <div className="p-6 space-y-6">
          <div className="text-center">
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Training Attempts 🏋️‍♂️
            </h3>
            <div className="flex items-center justify-center gap-4">
              <button
                onClick={() => setAttempts(Math.max(0, attempts - 1))}
                className="w-12 h-12 rounded-full bg-red-500 hover:bg-red-600 text-white font-bold text-xl transition-all duration-200 hover:scale-110 active:scale-95 shadow-lg"
              >
                -
              </button>
              <div className="bg-gray-100 rounded-xl px-6 py-3 min-w-[80px]">
                <span className="text-2xl font-bold text-gray-800">{attempts}</span>
              </div>
              <button
                onClick={() => setAttempts(attempts + 1)}
                className="w-12 h-12 rounded-full bg-blue-500 hover:bg-blue-600 text-white font-bold text-xl transition-all duration-200 hover:scale-110 active:scale-95 shadow-lg"
              >
                +
              </button>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3 text-center">
              How's it going? 🎪
            </h3>
            <div className="space-y-2">
              {proficiencyLevels.map((level) => (
                <button
                  key={level.value}
                  onClick={() => setProficiency(level.value)}
                  className={`w-full p-4 rounded-xl border-2 transition-all duration-200 ${
                    proficiency === level.value
                      ? 'border-blue-500 bg-blue-50 scale-105 shadow-lg'
                      : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <span className="text-2xl">{level.emoji}</span>
                    <div className="text-left">
                      <div className="font-semibold text-gray-800 text-sm">{level.label}</div>
                      <div className="text-sm text-gray-600">{level.desc}</div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          <div className="flex gap-3 pt-2 text-lg  font-semibold">
            <button
              onClick={() => handleUpdate(attempts, proficiency)}
              className="flex-1 bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg"
            >
              Save 💾
            </button>
            <button
              onClick={handleExit}
              className="flex-1 bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg"

            >
              Cancel ❌
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlaySkillFocus;